import { serializeQueryParams } from "@networx/utils/network/serialize-query-params";
import { useEffect, useRef } from "react";

export default function useTrustedForm() {
  const formRef = useRef<HTMLFormElement>(null);

  useEffect(() => {
    const existingScript = document.querySelector("script[src*='trustedform.com/trustedform.js']");
    if (!existingScript) {
      const queryParams = {
        provide_referrer: false,
        l: new Date().getTime() + Math.random(),
        invert_field_sensitivity: false,
      }
      const tf = document.createElement('script');
      tf.type = 'text/javascript';
      tf.async = true;
      tf.src = `https://api.trustedform.com/trustedform.js?${serializeQueryParams(queryParams)}`;
      document.body.appendChild(tf);
    }
  }, []);

  function getTrustedFormValues() {
    if (!formRef.current) throw new Error("Form is not set");
    let value = {};
    formRef.current.querySelectorAll<HTMLInputElement>('input[name^="xxTrustedForm"]').forEach((input) => {
      value = { ...value, [input.name]: input.value };
    });
    return value as Partial<TrustedForm>;
  }

  return {
    getTrustedFormValues,
    formRef,
  }

  type TrustedForm = {
    "xxTrustedFormToken": string;
    "xxTrustedFormCertUrl": string;
    "xxTrustedFormPingUrl": string;
  }
}
